<template>
  <div>
    <el-form
      :model="blogForm"
      :rules="rules"
      ref="blogForm"
      label-width="100px"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="资讯类别："
            prop="classId"
          >
            <el-select
              v-model="blogForm.classId"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item
            label="图片形式："
            prop=""
          >
            <el-radio
              v-model="format"
              label="1"
            >引用图片链接</el-radio>
            <el-radio
              v-model="format"
              label="2"
            >本地上传</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <div class="float-right">
            <el-button
              type="info"
              @click="cancel"
            >取消</el-button>
            <el-button
              type="primary"
              @click="issueBlog('blogForm')"
            >修改资讯</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            v-if="format == 1"
            label="封面图片："
            prop="imgUrlLink"
          >
            <el-input
              style=""
              v-model="blogForm.imgUrlLink"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-else
            label="封面图片："
            prop="imgUrl"
          >
            <el-upload
              class="avatar-uploader"
              name="img"
              :action="$http.defaults.baseURL + '/upload'"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                v-if="blogForm.imgUrl"
                :src="blogForm.imgUrl.includes('cnd.saishiquan.cn')?blogForm.imgUrl: $http.defaults.resource + blogForm.imgUrl"
                fit="contain"
                class="avatar"
              ></el-image>
              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item
            label="资讯标题："
            prop="title"
          >
            <el-input v-model="blogForm.title"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item
            label="资讯来源："
            prop="source"
          >
            <el-input v-model="blogForm.source"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="关联赛事："
            prop="views"
          >
            <el-select
              v-model="blogForm.relateMatchId"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in matchOptions"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-form-item
            label="编辑作者："
            prop="author"
          >
            <el-input v-model="blogForm.author"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="浏览量："
            prop="views"
          >
            <el-input-number
              v-model="blogForm.views"
              :min="0"
              :max="1000000"
              label="请输入浏览量"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="正文：">
            <ckEditor v-model="html"></ckEditor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import ckEditor from "@/components/ckEditor.vue";
export default {
  components: { ckEditor },
  data() {
    return {
      format: "1",
      blogForm: {
        classId: "",
        imgUrlLink: "",
        // 博客标题
        imgUrl: "",
        title: "",
        source: "",
        author: "",
        views: 0,
        relateMatchId:''
      },
      matchOptions: [],
      rules: {
        imgUrlLink: [
          {
            required: true,
            message: "请输入图片链接",
            trigger: "blur",
          },
        ],
        imgUrl: [
          {
            required: true,
            message: "请上传图片",
            trigger: "blur",
          },
        ],
        classId: [{ required: true, message: "请选择分类", trigger: "blur" }],
        title: [
          { required: true, message: "请输入资讯标题", trigger: "blur" },
          {
            min: 3,
            max: 500,
            message: "长度在 3 到 500 个字符",
            trigger: "blur",
          },
        ],
        source: [
          { required: true, message: "请填写资讯来源", trigger: "blur" },
        ],
        author: [
          { required: true, message: "请填写编辑作者", trigger: "blur" },
        ],
      },
      // 博客分类数组
      classArr: [],
      options: [],
      // 富文本实例
      editor: null,
      html: "<p></p>",
      toolbarConfig: {},
      editorConfig: {
        placeholder: "请输入内容...",
        MENU_CONF: {
          uploadImage: {
            server: this.$http.defaults.baseURL + "/upload",
            fieldName: "img",
            headers: { Accept: "multipart/form-data" },
            customInsert: (result, insertImg) => {
              // 上传成功 result为后台处理函数返回的数据
              var url = this.$http.defaults.resource + result.data;
              insertImg(url); //根据返回的图片路径，将图片插入到页面中，回显
            },
          },
        },
      },
      mode: "default", // or 'simple'
    };
  },
  watch: {},
  created() {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
    }
  },
  mounted() {
    // this.createWangEditor();
    this.getClass();
    this.getMatch();
  },
  methods: {
    // 获取赛事列表
    getMatch() {
      this.$http
        .post("/match/getInfo", {
          page_size: 99999999999999,
          page_index: 1,
          filter: {
            title: "",
            status: "",
            classId: "",
            timeStatus: "",
            adminId: "",
            admins: JSON.parse(localStorage.getItem("admins")),
          },
        })
        .then((res) => {
          if (res.status !== 200) return;
          this.matchOptions = res.data.blogs.map((item) => {
            return {
              id: item.id,
              label: item.title,
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    // 获取信息
    getDetail(id) {
      this.$http
        .get("/getDetail", {
          params: {
            id,
          },
        })
        .then((res) => {
          if (res.status !== 200) return;
          let data = res.data.data;
          if (!data.length) {
            this.$message.error("该资讯已失效");
            setTimeout(() => {
              this.$router.push("/edit");
            }, 2000);
            return;
          } else {
            this.blogForm.classId = data[0].classId;
            this.blogForm.title = data[0].title;
            this.blogForm.source = data[0].source;
            this.blogForm.author = data[0].author;
            this.blogForm.relateMatchId = data[0].relateMatchId;
            this.blogForm.views = data[0].views;
            // this.editor.txt.html(data[0].content);
            this.html = data[0].content;
            if (!data[0].imgUrl.includes("http")) {
              this.format = "2";
              this.blogForm.imgUrl = data[0].imgUrl;
            } else {
              this.blogForm.imgUrlLink = data[0].imgUrl;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取分类
    getClass() {
      this.$http
        .get("/getClass")
        .then((res) => {
          console.log(res);
          if (res.status !== 200) return;
          this.options = res.data.blogs;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 创建富文本
    createWangEditor() {
      //   创建富文本编辑器
      let that = this;
      var editor = new E("#editor");
      // 或者 var editor = new E( document.getElementById('editor') )
      // 配置服务器端地址
      editor.customConfig.uploadImgServer =
        that.$http.defaults.baseURL + "/upload";
      //自定义 fileName
      editor.customConfig.uploadFileName = "img";
      //自定义 header
      editor.customConfig.uploadImgHeaders = {
        Accept: "multipart/form-data",
      };
      editor.customConfig.uploadImgHooks = {
        success: function (xhr, editor, result) {
          console.log("图片上传并返回结果,图片插入成功");
        },
        fail: function (xhr, editor, result) {
          console.log("图片上传并返回结果，但图片插入错误");
        },
        error: function (xhr, editor) {
          console.log("图片上传出错");
        },
        timeout: function (xhr, editor) {
          console.log("图片上传超时");
        },
        customInsert: function (insertImg, result, editor) {
          // 上传成功 result为后台处理函数返回的数据
          var url = that.$http.defaults.resource + result.data;
          insertImg(url); //根据返回的图片路径，将图片插入到页面中，回显
        },
      };
      editor.create();
      this.editor = editor;
    },
    // 资讯发布
    issueBlog(formName) {
      // 表单验证
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          var reg = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
          if (this.format == "1" && !reg.test(that.blogForm.imgUrlLink)) {
            return this.$message.error(
              "封面图片必须以http://或者https://开头，且必须是个有效链接~"
            );
          }
          if (this.format == "2") {
            that.blogForm.imgUrlLink = "";
          }
          //   发送请求
          let load = this.$loading();
          debugger
          that.$http
            .post("/modifyDetail", {
              id: this.$route.query.id,
              title: that.blogForm.title,
              classId: that.blogForm.classId,
              author: that.blogForm.author,
              source: that.blogForm.source,
              relateMatchId: that.blogForm.relateMatchId,
              imgUrl: that.blogForm.imgUrlLink || that.blogForm.imgUrl,
              content: this.html,
              views: that.blogForm.views,
            })
            .then((res) => {
              load.close();
              if (res.status !== 200) {
                this.$message({
                  showClose: true,
                  message: "修改失败",
                  type: "error",
                });
                return;
              }
              if (res.data.code == -1) {
                this.$message({
                  showClose: true,
                  message: "资讯标题重复",
                  type: "error",
                });
                return;
              }
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
              // this.blogForm = {
              //   imgUrl: "",
              //   classId: "",
              //   title: "",
              //   source: "",
              //   author: "",
              //   views: 0,
              // };
              if (window.opener) {
                // 调用父窗口函数
                window.opener.getInfo();
              }
              setTimeout(() => {
                this.cancel();
              }, 1000);
            })
            .catch((err) => {
              console.log("失败");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      if (res && res.code == 0) {
        debugger
        this.blogForm.imgUrl = res.data;
      } else {
        this.$message({
          showClose: true,
          message: "上传失败",
          type: "error",
        });
      }
      this.$refs.blogForm.validateField("imgUrl");
    },
    // 上传之前
    beforeAvatarUpload(file) {
      let ftype = file.type === "image/jpeg" || file.type === "image/png";

      if (!ftype) {
        this.$message.error("上传图片只能是 JPG 或 PNG格式!");
      }
      //设置文件大小限制
      const isLt10M = file.size / 1024 / 1024 < 1;
      if (!isLt10M) {
        this.$message.error("上传的照片大小不能超过 1MB!");
        return false;
      }
      const isLt1M = file.size / 1024 / 1024 < 0.1;
      if (!isLt1M) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0, img.width, img.height);

              // Adjust the quality (0.5 for 50% quality, for example)
              const dataUrl = canvas.toDataURL("image/jpeg", 0.5);
              // Convert the data URL back to a File object
              const compressedFile = this.dataURLtoFile(dataUrl, file.name);

              resolve(compressedFile);
            };
          };
        });
      }
      return ftype;
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    // cancel
    cancel() {
      window.opener = null;
      window.open("about:blank", "_top").close();
    },
  },
};
</script>
<style lang='less' scoped>
form {
  margin-top: 30px;
  width: 100%;
  padding: 0 40px;
}
#editor {
  margin-top: 0px;
}

// 上传部分
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>